export default __webpack_public_path__ + "static/media/sealed_scroll.f9b8e0be.png";